/* eslint-disable no-console */

const makeRequestToSaveForLaterODM = async () => {
  const saveForLaterList: { savedProducts: { productId: string; skuId: string }[] } = {
    savedProducts: [],
  };

  if (!window?.ODM?.s4l?.getList) {
    console.warn('ODM S4L API is not available');
    return saveForLaterList;
  }

  try {
    const { data } = await window.ODM.s4l.getList();

    data.items.forEach((item: any) => {
      const { productId, skuId } = item;

      saveForLaterList.savedProducts.push({ productId, skuId });
    });
  } catch (error) {
    console.error('Failed to fetch S4L items', error);
  }

  return saveForLaterList;
};

const addProductToSaveForLater = async (skuId: string) => {
  if (!window?.ODM?.s4l?.updateList) {
    console.warn('ODM S4L updateList API is not available');
    return;
  }

  try {
    await window.ODM.s4l.updateList({ addSkus: [skuId] });
  } catch (error) {
    console.error('Failed to add item to S4L', error);
  }
};

const removeProductFromSaveForLater = async (skuId: string) => {
  if (!window?.ODM?.s4l?.updateList) {
    console.warn('ODM S4L updateList API is not available');
    return;
  }

  try {
    await window.ODM.s4l.updateList({ removeSkus: [skuId] });
  } catch (error) {
    console.error('Failed to remove item from S4L', error);
  }
};

export { addProductToSaveForLater, removeProductFromSaveForLater, makeRequestToSaveForLaterODM };
